import { useLanguageStore, useUserInfoStore } from 'store'
import { PageRoutes as CloudComputingPowerRoutes } from 'cloud-computing-power/constants/PageRoutes'
import { ElCollapse, ElCollapseItem, ElSpace } from 'element-plus'
import classNames from 'classnames'
import { useI18n } from 'i18n-utils'
import { ArrowRight, CurrencyIcon, CustomButton, DialogHeader, HocElDialog, ListCell, PhoneDownloadIcon, PhoneLanguageIcon, SizedBox, useDialog } from 'ui-components'
import { DefineComponentProps } from 'utils'
import { PageRoutes } from 'crypto-otc/constants/PageRoutes'
import { useDownloadConfig } from 'crypto-otc/hooks/use-download-config'
import { HomeMobileMenuLayout } from 'crypto-otc/components/HomeMobileMenu.layout'
import { MobileChangeLanguage } from 'crypto-otc/components/MobileChangeLanguage'
import { MobileChangeCurrency } from 'crypto-otc/components/MobileChangeCurrency'
import { getLangName } from 'crypto-otc/constants/ElementPlusLangConfig'

interface HomeMobileMenuProps {
  onClose: () => void
}

export const HomeMobileMenu = defineComponent<HomeMobileMenuProps>({
  props: DefineComponentProps<HomeMobileMenuProps>(['onClose']),
  setup(props) {
    const { t } = useI18n()
    const router = useRouter()
    const userInfoStore = useUserInfoStore()
    const languageStore = useLanguageStore()

    const { dialogVisible, openDialog, closeDialog } = useDialog()
    const { onGoToDownloadAndroid, onGoToDownloadIos, onGoToDownloadGooglePlay } = useDownloadConfig()
    const { dialogVisible: currencyDialogVisible, openDialog: openCurrencyDialog, closeDialog: closeCurrencyDialog } = useDialog()

    const onGotoPage = (route: PageRoutes) => {
      dialogVisible.value = false
      props.onClose?.()
      router.push(route)
    }

    const currentLanguageName = computed(() => {
      return getLangName(languageStore.currentLanguage)
    })

    const gotoBuyCloud = () => {
      props.onClose?.()
      router.push(CloudComputingPowerRoutes.Cloud)
    }

    const gotoCloudOrder = () => {
      props.onClose?.()
      router.push(CloudComputingPowerRoutes.Order)
    }

    const gotoCloudIncome = () => {
      props.onClose?.()
      router.push(CloudComputingPowerRoutes.Income)
    }

    const gotoCloudCalculator = () => {
      props.onClose?.()
      router.push(CloudComputingPowerRoutes.Calculator)
    }

    const gotoHome = () => {
      props.onClose?.()
      router.push(PageRoutes.Home)
    }

    return () => (
      <HomeMobileMenuLayout class="default-container">
        {!userInfoStore.isLogin && (
          <>
            <SizedBox height={16} />
            <CustomButton class="register-login login" onClick={() => onGotoPage(PageRoutes.Login)}>
              {t('登录')}
            </CustomButton>
            <CustomButton type="primary" class="register-login" onClick={() => onGotoPage(PageRoutes.Register)}>
              {t('注册')}
            </CustomButton>
            <SizedBox height={16} />
          </>
        )}

        <SizedBox height={16} />
        <ListCell title={t('首页')} onClick={gotoHome} isArrow />

        <ListCell title={t('购买算力')} onClick={gotoBuyCloud} isArrow />
        {userInfoStore.isLogin && (
          <>
            <ListCell title={t('算力订单')} onClick={gotoCloudOrder} isArrow />
            <ListCell title={t('算力收益')} onClick={gotoCloudIncome} isArrow />
          </>
        )}

        <ListCell title={t('计算器')} onClick={gotoCloudCalculator} isArrow />

        <div class="divider" />
        <ElCollapse>
          <ElCollapseItem>
            {{
              title: () => (
                <ElSpace size={2}>
                  <PhoneDownloadIcon />
                  {t('下载App')}
                </ElSpace>
              ),
              default: () => (
                <>
                  <ListCell title={t('谷歌商店下载')} onClick={onGoToDownloadGooglePlay} />
                  <ListCell title={t('苹果商店下载')} onClick={onGoToDownloadIos} />
                  <ListCell title={t('APK下载')} onClick={onGoToDownloadAndroid} />
                </>
              ),
              icon: ({ isActive }: { isActive: boolean }) => (
                <span class={classNames('arrow-right-icon', { active: isActive })}>
                  <ArrowRight />
                </span>
              ),
            }}
          </ElCollapseItem>
        </ElCollapse>
        <ListCell prefix={<PhoneLanguageIcon />} title={t(currentLanguageName.value)} isArrow onClick={openDialog} />
        <ListCell prefix={<CurrencyIcon />} title={userInfoStore.currentToCurrency.toUpperCase()} isArrow onClick={openCurrencyDialog} />

        <HocElDialog v-model={dialogVisible.value} placement="bottom" closeOnClickModal={false} modal={true} offsetTop={64} showClose={false} onClose={closeDialog} appendToBody>
          {{
            header: () => <DialogHeader onClose={closeDialog}>{t('语言')}</DialogHeader>,
            default: () => <MobileChangeLanguage onLanguageChange={closeDialog} />,
          }}
        </HocElDialog>

        <HocElDialog
          v-model={currencyDialogVisible.value}
          placement="bottom"
          closeOnClickModal={false}
          modal={true}
          offsetTop={64}
          showClose={false}
          onClose={closeCurrencyDialog}
          appendToBody
        >
          {{
            header: () => <DialogHeader onClose={closeCurrencyDialog}>{t('法币')}</DialogHeader>,
            default: () => <MobileChangeCurrency onCurrencyChange={closeCurrencyDialog} />,
          }}
        </HocElDialog>
      </HomeMobileMenuLayout>
    )
  },
})
